import React from 'react';
import { useNavigate } from 'react-router-dom';

const reports = [
  {
    id: 'neraca',
    title: 'Neraca',
    desc: 'Menampilkan apa yang dimiliki (aset), apa saja utangnya (liabilitas), dan apa yang sudah diinvestasikan ke perusahaan ini (ekuitas) pada tanggal tertentu.'
  },
  {
    id: 'laba-rugi',
    title: 'Laba rugi',
    desc: 'Menampilkan semua pendapatan yang diperoleh dan biaya yang dikeluarkan dalam periode tertentu.'
  },
  {
    id: 'arus-kas',
    title: 'Arus kas',
    desc: 'Menampilkan pergerakan uang masuk dan keluar dari transaksi dalam periode tertentu.'
  },
  {
    id: 'buku-besar',
    title: 'Buku besar',
    desc: 'Menampilkan semua transaksi berdasarkan akun dalam periode tertentu, termasuk kronologi pergerakan transaksinya selama periode berlangsung.'
  },
  {
    id: 'perubahan-modal',
    title: 'Perubahan modal',
    desc: 'Menampilkan perubahan atau pergerakan ekuitas pemilik dalam periode tertentu.'
  },
  {
    id: 'jurnal',
    title: 'Jurnal',
    desc: 'Menampilkan semua journal entry per transaksi dalam periode tertentu. Anda dapat melacak transaksi yang masuk ke masing-masing akun.'
  }
];

export default function FinanceReportsHub() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 animate-in fade-in zoom-in duration-500">
      {/* Header */}
      <div className="bg-[#FFFDF9] border border-[#E6D5B8]/60 rounded-2xl p-6 shadow-sm relative overflow-hidden">
        <h1 className="text-2xl font-black text-[#302621] tracking-tight">Laporan</h1>
        
        <div className="flex gap-6 mt-4 text-sm font-medium border-b border-[#E6D5B8]/40 pb-2">
          <button className="text-[#4F46E5] border-b-2 border-[#4F46E5] pb-2">Sekilas bisnis</button>
          <button className="text-[#7A695B] hover:text-[#302621]">Penjualan</button>
          <button className="text-[#7A695B] hover:text-[#302621]">Pembelian</button>
          <button className="text-[#7A695B] hover:text-[#302621]">Produk</button>
          <button className="text-[#7A695B] hover:text-[#302621]">Aset</button>
          <button className="text-[#7A695B] hover:text-[#302621]">Bank</button>
          <button className="text-[#7A695B] hover:text-[#302621]">Pajak</button>
          <button className="text-[#7A695B] hover:text-[#302621]">Produksi</button>
        </div>
      </div>

      {/* Grid Reports */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {reports.map((report) => (
          <div key={report.id} className="bg-white border border-[#E6D5B8]/60 rounded-xl p-6 shadow-sm hover:border-[#8C6208]/40 transition-colors flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-[#302621] text-base mb-2">{report.title}</h3>
              <p className="text-sm text-[#7A695B] leading-relaxed">
                {report.desc}
              </p>
            </div>
            <div className="mt-6">
              <button 
                onClick={() => navigate(`/office/finance/reports-hub/${report.id}`)}
                className="text-sm font-semibold text-[#8C6208] hover:text-[#A37B24] border border-[#E6D5B8] rounded-lg px-4 py-2 hover:bg-[#F9F5EC] transition-all"
              >
                Lihat laporan
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
